import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useI18n, urlLang } from '../i18n/index.jsx';

// Shown once, right after the language was chosen automatically (first
// visit): "Site affiché en français · Switch to English". The switch link
// is written in the other language on purpose. Picking saves the choice.
export default function LangBar() {
  const { t, lang, setLang, langBar, dismissBar } = useI18n();
  if (!langBar) return null;
  const other = lang === 'fr' ? 'en' : 'fr';
  return (
    <div className="lang-bar" role="status">
      <div className="container lang-bar-inner">
        <span>{t('langBar.showing')}</span>
        <span aria-hidden="true">·</span>
        <button type="button" className="lang-bar-switch" lang={other} onClick={() => setLang(other)}>{t('langBar.switch')}</button>
        <button type="button" className="lang-bar-close" onClick={dismissBar} aria-label={t('langBar.close')}>×</button>
      </div>
    </div>
  );
}

// ?lang=fr|en (or /fr/…, /en/…) in a link followed inside the site.
export function useUrlLang() {
  const location = useLocation();
  const { applyUrlLang } = useI18n();
  useEffect(() => {
    const l = urlLang(location);
    if (l) applyUrlLang(l);
  }, [location, applyUrlLang]);
}
